export enum IdpOauth2LoginScope {
    OPENID = 'openid',
    EMAIL = 'email',
    PROFILE = 'profile'
}
